import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface WhaticketTabProps {
  integration: Integration | null;
}

function WhaticketTab({ integration }: WhaticketTabProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="ticketz_url">URL Whaticket</FormLabel>
          <FormInput id="ticketz_url" name="ticketz_url" defaultValue={integration?.ticketz_url} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ticketz_token">Token Whaticket</FormLabel>
          <FormInput
            id="ticketz_token"
            name="ticketz_token"
            defaultValue={integration?.ticketz_token}
          />
        </FormField>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="ticketz_companyId">ID da Empresa</FormLabel>
          <FormInput
            type="number"
            id="ticketz_companyId"
            name="ticketz_companyId"
            defaultValue={integration?.ticketz_companyId}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="ticketz_userId">ID do Usuário</FormLabel>
          <FormInput
            type="number"
            id="ticketz_userId"
            name="ticketz_userId"
            defaultValue={integration?.ticketz_userId}
          />
        </FormField>
      </div>
    </div>
  );
}

export default WhaticketTab;
